import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/network/";

export default class NetworkApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getNetworks(params) {
    return await request.post(`${rootRoute}getNetworks`, {
      filter: params,
      parameters: {},
    });
  }
  async getNetwork(id) {
    return await request.post(`${rootRoute}getNetworks`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createNetwork(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createNetwork`, { data });
  }
  async deleteNetwork(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteNetwork`, { data });
  }
  async editNetwork(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateNetwork`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importNetwork`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getNetworkimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportNetwork`, {
      filter: filter,
      format: format
    });
  }
}
